import template from './preview-window.template.html';

export class PreviewWindowService {

    constructor($log, $uibModal) {
        'ngInject';

        this.$log = $log;
        this.$uibModal = $uibModal;

    }

    open(title, image) {

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            controller: function() {
                'ngInject';
                this.title = title;
                this.image = image;
            },
            controllerAs: '$ctrl',
            size: 'lg'
        });

        modalInstance.result.then(() => {

        }, () => {
            this.$log.info('Modal dismissed at: ' + new Date());
        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/preview-window/preview-window.service.js